import { render } from "./upvoty-nav-item.vue?vue&type=template&id=423a1f41"
import script from "./upvoty-nav-item.vue?vue&type=script&lang=js"
export * from "./upvoty-nav-item.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_b6f5290c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__